// extracted by mini-css-extract-plugin
export default {"aboutTitle":"About_aboutTitle__Q-M56","aboutText":"About_aboutText__3xafr"};